import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { DiagramEditorView } from '@/features/diagrams/DiagramEditorView.js';
import { ensureDiagramsEnabled } from '@/features/diagrams/guard.js';

// One diagram, open for editing. The editor loads its own document so a deep link works
// without going through the gallery first.
export const Route = createFileRoute('/diagrams/$id')({
  beforeLoad: async () => {
    await ensureDiagramsEnabled();
  },
  component: DiagramPage,
});

function DiagramPage(): JSX.Element {
  const { id } = Route.useParams();
  return <DiagramEditorView diagramId={id} />;
}
